import { send } from 'server';
import { JUMIO_HAVE_COPY_ID_FAX_KEY } from 'js/components/main/Jumio/constants';

export const TAG_NAME = 'risk/doc/upload_requirement';

export const verifyNow = ({ documentType, successUrl, errorUrl }) => send({
    ID: 35688,
    description: 'Initiate document upload request',
    responses: [35689, 35690],
    service: 'netverify',
    documentType,
    successUrl,
    errorUrl
});

export const getPlayerHaveIdCopyFax = () => send({
    ID: 31082,
    responses: [31083, 31084],
    requestedPlayerData: [
        JUMIO_HAVE_COPY_ID_FAX_KEY
    ],
    requestType: 'marked',
    description: 'Get player haveidcopyfax'
});

export const getPlayerTags = () => send({
    ID: 35547,
    responses: [35548, 35549],
    description: 'Get Player Tags Request',
    tagName: TAG_NAME
});
